import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import Loader from '../../../components/Common/Loader/Loader';
import NotFound from '../../../components/NotFound/NotFound';
import getEditStaticPage from './getEditStaticPage.graphql'
import messages from '../../../locale/messages';
import { withQuery } from '../../../hoc/withGraphql';

export class EditStaticPage extends Component {

  static defaultProps = {
    data: {
      loading: true
    }
  }

  constructor(props) {
    super(props)
    this.component = null;
  }

  componentDidMount() {
    if (typeof window !== 'undefined' && typeof document !== undefined) {
      this.component = require('../../../components/SiteAdmin/StaticPageEditForm').default
    }
  }

  render() {
    const { data: { loading, getEditStaticPage } } = this.props;
    const { formatMessage } = this.props.intl;
    const isBrowser = typeof window !== 'undefined';
    const isDocument = typeof document !== undefined;
    const StaticPageEditForm = this.component;

    let title = formatMessage(messages.staticpageManagement);
    let initialValues = {};
    if (getEditStaticPage && getEditStaticPage?.result) {
      initialValues = {
        id: getEditStaticPage?.result?.id,
        pageName: getEditStaticPage?.result?.pageName,
        createdAt: getEditStaticPage?.result?.createdAt,
        metaTitle: getEditStaticPage?.result?.metaTitle,
        metaDescription: getEditStaticPage?.result?.metaDescription,
        pageBanner: getEditStaticPage?.result?.pageBanner
      }
      if (getEditStaticPage?.result?.dynamicStaticContent?.length > 0) {
        initialValues['content'] = getEditStaticPage?.result?.dynamicStaticContent?.map((item) => ({
          content: item?.content || getEditStaticPage?.result?.content,
          language: item?.language || 'en-US'
        }))
      } else {
        initialValues['content'] = [{ content: getEditStaticPage?.result?.content, language: 'en-US' }]
      }
    }

    if (!loading && !getEditStaticPage?.result?.id) {
      return <NotFound title={formatMessage(messages.pageNotFound)} />;
    } else {
      return (
        <Loader type={"page"} show={loading}>
          {!loading && isBrowser && isDocument && <StaticPageEditForm title={title} initialValues={initialValues} />}
        </Loader>
      )
    }
  }
}


export default compose(injectIntl, withQuery(getEditStaticPage, {
  options: (props) => ({
    variables: {
      id: Number(props.id)
    },
    fetchPolicy: 'network-only',
    ssr: false
  })
}))(EditStaticPage)
